import React, { Component } from "react";

import { Container } from './style'

class AppIcons extends Component {
  iconHome() {
    return (
      <Container size={this.props.size+'px'}>
        <svg 
          width={this.props.size + "px"} 
          height={this.props.size + "px"} 
          fill={this.props.color}
          viewBox="0 0 28 28" 
          xmlns="http://www.w3.org/2000/svg">
          <path 
            d="M5.42857 4C4.4818 4 3.71429 4.76751 3.71429 5.71429C3.71429 6.66106 4.4818 7.42857 5.42857 7.42857C14.8963 7.42857 22.5714 15.1037 22.5714 24.5714C22.5714 25.5182 23.3389 26.2857 24.2857 26.2857C25.2325 26.2857 26 25.5182 26 24.5714C26 13.2101 16.7899 4 5.42857 4Z" 
            fill={this.props.color}/>
          <path 
            d="M3.71429 14.2857C3.71429 13.3389 4.4818 12.5714 5.42857 12.5714C12.056 12.5714 17.4286 17.944 17.4286 24.5714C17.4286 25.5182 16.6611 26.2857 15.7143 26.2857C14.7675 26.2857 14 25.5182 14 24.5714C14 19.8376 10.1624 16 5.42857 16C4.4818 16 3.71429 15.2325 3.71429 14.2857Z" 
            fill={this.props.color}/>
          <path 
            d="M2 24.5714C2 22.6779 3.53502 21.1429 5.42857 21.1429C7.32212 21.1429 8.85714 22.6779 8.85714 24.5714C8.85714 26.465 7.32212 28 5.42857 28C3.53502 28 2 26.465 2 24.5714Z" 
            fill={this.props.color}/>
        </svg>
      </Container>
    );
  }
  iconGift() {
    return (
      <Container size={this.props.size+'px'}>
        <svg 
          width={this.props.size + "px"} 
          height={this.props.size + "px"} 
          fill={this.props.color} 
          viewBox="0 0 28 28" 
          xmlns="http://www.w3.org/2000/svg">
          <path 
            d="M3.5625 2C2.69956 2 2 2.68474 2 3.52941C2 4.37408 2.69956 5.05882 3.5625 5.05882H5.46754L5.94497 6.92814C5.94999 6.94975 5.95546 6.97119 5.9614 6.99244L8.08207 15.2955L6.68742 16.6606C4.71879 18.5876 6.11305 21.8824 8.89713 21.8824H22.3124C23.1754 21.8824 23.8749 21.1976 23.8749 20.3529C23.8749 19.5083 23.1754 18.8235 22.3124 18.8235L8.89713 18.8235L10.4596 17.2941H20.75C21.3418 17.2941 21.8829 16.9668 22.1475 16.4487L26.835 7.27221C27.0772 6.79811 27.0513 6.23507 26.7666 5.78418C26.4819 5.33328 25.979 5.05882 25.4375 5.05882H8.68871L8.20335 3.15847C8.02945 2.47763 7.40448 2 6.6875 2H3.5625Z" 
            fill={this.props.color}/>
          <path 
            d="M23.875 25.7059C23.875 26.9729 22.8257 28 21.5312 28C20.2368 28 19.1875 26.9729 19.1875 25.7059C19.1875 24.4389 20.2368 23.4118 21.5312 23.4118C22.8257 23.4118 23.875 24.4389 23.875 25.7059Z" 
            fill={this.props.color}/>
          <path 
            d="M9.03125 28C10.3257 28 11.375 26.9729 11.375 25.7059C11.375 24.4389 10.3257 23.4118 9.03125 23.4118C7.73683 23.4118 6.6875 24.4389 6.6875 25.7059C6.6875 26.9729 7.73683 28 9.03125 28Z" 
            fill={this.props.color}/>
        </svg>
      </Container>
    );
  }
  iconLightning() {
    return (
      <Container size={this.props.size + "px"}>
        <svg
          version="1.1"
          id="Layer_1"
          width={this.props.size + "px"}
          height={this.props.size + "px"}
          viewBox="0 0 1024 1024"
          enableBackground="new 0 0 512 512"
        >
          <path
          fill={this.props.color}
          d="M281.674 253.424c11.553-14.585 24.288-28.14 38.208-40.267l-68.978-69.013c-10.828-10.867-28.404-10.867-39.275 0-10.831 10.831-10.831 28.404 0 39.235l70.046 70.043zM506.013 142.469c0.268 0 0.494 0 0.802 0 9.109 0 18.109 0.571 26.955 1.487l0-93.986c0-15.327-12.432-27.757-27.76-27.757s-27.721 12.429-27.721 27.757l0 93.968c8.846-0.895 17.842-1.469 26.956-1.469 0.27 0 0.534 0 0.762 0zM730.414 253.388l69.971-70.007c10.866-10.831 10.866-28.404 0-39.235-10.794-10.867-28.405-10.867-39.277 0l-69.018 69.013c13.958 12.123 26.695 25.664 38.324 40.227zM213.494 450.225c0-13.403 1.07-26.519 2.633-39.483l-98.682 0c-15.289 0-27.722 12.432-27.722 27.757 0 15.328 12.434 27.757 27.722 27.757l96.393 0c-0.229-5.28-0.345-10.581-0.345-16.033zM894.563 410.745l-98.643 0c1.6 12.964 2.633 26.082 2.633 39.483 0 5.45-0.115 10.753-0.305 16.033l96.315 0c15.332 0 27.722-12.429 27.722-27.757s-12.39-27.757-27.722-27.757zM745.017 638.262c-11.286 16.547-23.218 30.843-34.695 43.77l50.787 50.829c10.868 10.831 28.483 10.831 39.277 0 10.866-10.867 10.866-28.404 0-39.275l-55.37-55.324zM211.627 693.585c-10.831 10.867-10.831 28.404 0 39.275 10.868 10.831 28.448 10.831 39.275 0l50.83-50.863c-11.475-12.889-23.412-27.222-34.699-43.731l-55.403 55.324zM760.039 450.225c0.037-57.556-19.138-110.785-51.438-153.414-28.33-37.442-66.806-66.802-111.379-84.036l0.229-1.222-19.026-5.586c-14.798-4.29-30.051-7.265-45.605-8.867l-2.211-0.246-0.075 0-0.079-0.019c-7.623-0.724-15.557-1.279-23.83-1.279l-1.218 0c-8.276 0-16.207 0.557-23.833 1.279l-0.115 0.019-2.286 0.246c-15.535 1.6-30.791 4.575-45.549 8.867l-18.416 5.374 0.19 1.222c-44.802 17.214-83.505 46.651-111.99 84.244-32.258 42.628-51.438 95.854-51.438 153.414 0 41.274 7.132 75.207 18.227 103.29 16.661 42.114 42.094 70.559 62.533 92.138 10.22 10.754 19.22 19.941 25.317 27.795 6.254 7.892 9.265 13.995 10.141 18.837 4.459 23.565 4.917 53.306 4.917 60.854l0 2.174c0 34.085 27.609 61.617 61.659 61.655l142.51 0c34.092-0.037 61.659-27.609 61.659-61.655l0-2.097c-0.037-7.474 0.458-37.291 4.919-60.893 0.608-3.278 2.058-7.017 4.917-11.591 4.88-7.97 14.11-17.883 25.548-29.819 17.083-17.959 38.815-40.604 56.091-72.805 17.312-32.161 29.703-73.706 29.626-127.882zM701.813 537.676c-13.614 34.336-34.053 57.575-53.763 78.391-9.841 10.411-19.487 20.095-27.911 30.812-8.311 10.562-15.745 22.65-18.606 37.481-5.377 28.94-5.607 59.978-5.638 68.862 0 1.181 0 1.828 0 2.096-0.037 10.295-8.314 18.606-18.608 18.606l-142.51 0c-5.223 0-9.761-2.059-13.194-5.45-3.391-3.434-5.412-7.934-5.412-13.154 0-0.268 0-0.953 0-2.172-0.037-8.957-0.306-39.921-5.682-68.783-1.828-9.797-5.834-18.571-10.674-26.348-8.579-13.612-19.559-24.819-30.889-36.832-17.116-17.842-35.232-37.119-49.341-63.41-14.07-26.309-24.517-59.745-24.557-107.54 0.037-47.947 15.862-91.95 42.706-127.427 26.845-35.442 64.595-62.209 108.175-75.246l5.377-1.638c10.524-2.708 21.315-4.861 32.429-6.026l0.075 0 2.06-0.229c6.519-0.627 12.847-1.03 19.103-1.066l1.105 0.115 1.106-0.076c6.212 0 12.579 0.42 19.063 1.03l-0.079 0 2.137 0.229 0.037 0c11.093 1.163 21.887 3.277 32.372 6.026l5.451 1.638c43.582 13.037 81.329 39.807 108.175 75.246 26.801 35.478 42.666 79.482 42.666 127.427 0.003 36.409-6.094 64.511-15.169 87.446zM532.782 197.107l0.079 0zM479.17 197.107l0 0c0 0 0.037 0 0.075 0l-0.075 0zM576.706 833.825l-141.369 0c-14.604 0-26.499 11.822-26.499 26.539 0 14.564 11.899 26.465 26.499 26.465l141.369 0c14.604 0 26.499-11.899 26.499-26.465 0-14.721-11.899-26.539-26.499-26.539zM576.706 900.704l-141.369 0c-14.604 0-26.499 11.857-26.499 26.464 0 14.678 11.899 26.539 26.499 26.539l141.369 0c14.604 0 26.499-11.857 26.499-26.539 0-14.605-11.899-26.464-26.499-26.464zM518.406 968.116l-72.805 0c0 0.801-0.154 1.561-0.154 2.404 0 14.643 22.498 26.499 43.297 26.499l34.546 0c20.818 0 43.277-11.857 43.277-26.499 0-0.837-0.115-1.6-0.115-2.404l-48.044 0z" />
        </svg>
      </Container>
    )
  }
  iconAttention() {
    return (
      <Container size={this.props.size+'px'}>
        <svg 
          xmlns="http://www.w3.org/2000/svg"
          width={this.props.size}
          height={this.props.size} 
          viewBox="0 0 22 22"
          fill={this.props.color}
        >
          <path d="M0 0h24v24H0V0z" fill="none"/>
          <path d="M22 4H2.01L2 20h20V4zm-2 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"/>
        </svg>
      </Container>
    );
  }
  iconPerson() {
    var size = this.props.size;
    return (
      <Container size={size+'px'}>
        <svg 
          width={this.props.size + "px"} 
          height={this.props.size + "px"} 
          fill={this.props.color}
          viewBox="0 0 28 28" 
          xmlns="http://www.w3.org/2000/svg">
          <path 
            d="M14.1463 15.3681C18.3901 15.3681 21.8304 11.9279 21.8304 7.68407C21.8304 3.44027 18.3901 0 14.1463 0C9.90249 0 6.46222 3.44027 6.46222 7.68407C6.46222 11.9279 9.90249 15.3681 14.1463 15.3681Z" 
            fill={this.props.color}/>
          <path 
            d="M14.0621 27.9879C14.0621 27.9879 20.2318 28.4927 25.3358 22.9681C25.3358 22.9681 25.7565 17.5836 21.7743 15.9851L18.9979 14.667C18.9979 14.667 18.6894 14.1342 18.8016 13.7135" 
            fill={this.props.color}/>
          <path 
            d="M14.2865 27.9879C14.2865 27.9879 8.11681 28.4927 3.0128 22.9681C3.0128 22.9681 2.59214 17.5836 6.57439 15.9851L9.35075 14.667C9.35075 14.667 9.65923 14.1342 9.54706 13.7135" 
            fill={this.props.color}/>
        </svg>
      </Container>
    );
  }
  iconLock() {
    return (
      <Container site={this.props.size + 'px'}>
        <svg 
          xmlns="http://www.w3.org/2000/svg"
          width={this.props.size || 15}
          height={this.props.size || 15} 
          viewBox="0 0 22 22"
          fill={this.props.color}
         
        >
            <g fill="none">
              <path d="M0 0h24v24H0V0z"/><path d="M0 0h24v24H0V0z" opacity=".87"/>
            </g>

          <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/>
        </svg>
      </Container>
    );
  }

  iconSearch() {
    return (
      <Container size={this.props.size + 'px'}>
        <svg 
          xmlns="http://www.w3.org/2000/svg"
          width={this.props.size || 15}
          height={this.props.size || 15} 
          viewBox="0 0 22 22"
          fill={this.props.color}
         
        >
           <path d="M0 0h24v24H0V0z" fill="none"/><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            
          </svg>
      </Container>
    );
  }

  iconQuiz() {
    return (
      <Container size={this.props.size + 'px'}>
        <svg
          
          viewBox="0 0 1792 1792"
          fill={this.props.color}
          width={this.props.size || 15}
          height={this.props.size || 15} 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1472 930v318q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q63 0 117 25 15 7 18 23 3 17-9 29l-49 49q-10 10-23 10-3 0-9-2-23-6-45-6h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-254q0-13 9-22l64-64q10-10 23-10 6 0 12 3 20 8 20 29zm231-489l-814 814q-24 24-57 24t-57-24l-430-430q-24-24-24-57t24-57l110-110q24-24 57-24t57 24l263 263 647-647q24-24 57-24t57 24l110 110q24 24 24 57t-24 57z" />
        </svg>
      </Container>
    );
  }

  iconQuizPop() {
    return (
      <Container size={this.props.size + 'px'}>
         <svg
          x="0px"
          y="0px"
          viewBox="0 0 415 415"
          width={this.props.size || 15}
          height={this.props.size || 15} 
        >
          <g>
            <g>
              <path
               fill={this.props.color}
                d="M325.662,3.768C324.325,1.437,321.844,0,319.157,0H164.555c-3.218,0-6.078,2.053-7.107,5.102L91.19,201.421
                c-0.772,2.289-0.394,4.81,1.014,6.772c1.409,1.962,3.677,3.126,6.093,3.126h62.812L88.817,404.876
                c-1.278,3.422,0.096,7.268,3.254,9.106c1.18,0.686,2.48,1.018,3.769,1.018c2.16,0,4.287-0.932,5.756-2.687l201.228-240.49
                c1.869-2.234,2.276-5.348,1.043-7.987c-1.232-2.639-3.882-4.326-6.795-4.326h-58.094l86.654-148.224
                C326.988,8.966,327,6.099,325.662,3.768z M219.429,163.223c-1.356,2.32-1.368,5.187-0.03,7.518
                c1.337,2.331,3.818,3.768,6.505,3.768h55.111L118.189,369.107l60.754-162.664c0.86-2.302,0.537-4.88-0.865-6.9
                c-1.401-2.019-3.703-3.224-6.161-3.224h-63.173L169.939,15h136.145L219.429,163.223z"
              />
            </g>
          </g>
        </svg>
      </Container>
    );
  }

  iconCamera() {
    return (
      <Container size={this.props.size+'px'}   fill={this.props.color} >
       <svg fill={this.props.color}   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"/></svg>
      </Container>
    );
  }
  
  iconHolerite() {
    return (
      <Container size={this.props.size + 'px'}>
        <svg
          width={this.props.size + "px"} 
          height={this.props.size + "px"} 
          fill="#999"
          viewBox="0 -2 20 28" 
        >
          <path d="M7 0C6.25739 0 5.5452 0.297478 5.0201 0.826993C4.495 1.35651 4.2 2.07468 4.2 2.82353V10.1746C4.65763 
            10.044 5.12631 9.95652 5.6 9.91341V2.82353C5.6 2.44911 5.7475 2.09002 6.01005 1.82526C6.2726 1.5605 6.6287 
            1.41176 7 1.41176H12.6V6.35294C12.6 6.91458 12.8212 7.45321 13.2151 7.85034C13.6089 8.24748 14.143 8.47059 
            14.7 8.47059H19.6V19.7647C19.6 20.1391 19.4525 20.4982 19.1899 20.763C18.9274 21.0277 18.5713 21.1765 
            18.2 21.1765H13.16C12.9052 21.6793 12.5967 22.1527 12.2402 22.5882H18.2C18.9426 22.5882 19.6548 22.2908 
            20.1799 21.7612C20.705 21.2317 21 20.5136 21 19.7647V7.64329C20.9995 7.08185 20.7779 6.54358 20.384 
            6.14682L14.9044 0.619765C14.5107 0.223033 13.977 0.000119832 13.4204 0H7ZM19.3102 7.05882H14.7C14.5143 
            7.05882 14.3363 6.98445 14.205 6.85208C14.0737 6.7197 14 6.54015 14 6.35294V1.704L19.3102 7.05882ZM6.3 
            24C7.97086 24 9.57329 23.3307 10.7548 22.1393C11.9363 20.9479 12.6 19.332 12.6 17.6471C12.6 15.9622 
            11.9363 14.3463 10.7548 13.1549C9.57329 11.9634 7.97086 11.2941 6.3 11.2941C4.62914 11.2941 3.02671 
            11.9634 1.84523 13.1549C0.663748 14.3463 0 15.9622 0 17.6471C0 19.332 0.663748 20.9479 1.84523 22.1393C3.02671 
            23.3307 4.62914 24 6.3 24ZM3.0044 18.1468C2.87296 18.0143 2.79912 17.8345 2.79912 17.6471C2.79912 17.4596 
            2.87296 17.2798 3.0044 17.1473C3.13584 17.0147 3.31411 16.9403 3.5 16.9403C3.68589 16.9403 3.86416 17.0147 
            3.9956 17.1473L5.6 18.7666V14.8235C5.6 14.6363 5.67375 14.4568 5.80503 14.3244C5.9363 14.192 6.11435 
            14.1176 6.3 14.1176C6.48565 14.1176 6.6637 14.192 6.79497 14.3244C6.92625 14.4568 7 14.6363 7 
            14.8235V18.7666L8.6044 17.1473C8.73584 17.0147 8.91411 16.9403 9.1 16.9403C9.28589 16.9403 9.46416 
            17.0147 9.5956 17.1473C9.72704 17.2798 9.80088 17.4596 9.80088 17.6471C9.80088 17.8345 9.72704 
            18.0143 9.5956 18.1468L6.7956 20.9704C6.6651 21.1016 6.48852 21.1757 6.3042 21.1765H6.2958C6.11333 
            21.1753 5.93852 21.1024 5.8086 20.9732L5.8044 20.9689L3.0044 18.1454V18.1468Z" 
            fill={this.props.color}
          />
        </svg>
      </Container>
    )
  }

  iconChannels() {
    return (
      <Container size={this.props.size + 'px'}>
        <svg width={this.props.size + 'px'} height={this.props.size + 'px'} fill={this.props.color} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"/>
        </svg>
      </Container>
    );
  }

  iconBeefiles() {
    return (
      <Container size={this.props.size + 'px'}>
        <svg width={this.props.size + 'px'} height={this.props.size + 'px'} fill={this.props.color} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"/>
        </svg>
      </Container>
    );
  }

  render() {
    if (this.props.icon === "home") {
      return this.iconHome();
    }
    if (this.props.icon === "lightning") {
      return this.iconLightning();
    }
    if (this.props.icon === "gift") {
      return this.iconGift();
    }
    if (this.props.icon === "person") {
      return this.iconPerson();
    }
    if (this.props.icon === "attention") {
      return this.iconAttention();
    }
    if (this.props.icon === "lock") {
      return this.iconLock();
    }
    if (this.props.icon === "search") {
      return this.iconSearch();
    }
    if (this.props.icon === "quiz") {
      return this.iconQuiz();
    }
    if (this.props.icon === "quizpop") {
      return this.iconQuizPop();
    }
    if (this.props.icon === "camera") {
      return this.iconCamera();
    }
    if (this.props.icon === "holerite") {
      return this.iconHolerite();
    }
    if (this.props.icon === "channels") {
      return this.iconChannels();
    }
    if (this.props.icon === "beefiles") {
      return this.iconBeefiles();
    }
    alert("icon not found: " + this.props.icon);
    return null;
  }
}
export default AppIcons;
